/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScheduleConfirmationAliases {
  CONTEXTUAL_BAR_APPOINTMENTS = 'contextual-bar-appointments',
  CONTEXTUAL_BAR_REQUEST = 'contextual-bar-request',
  CONTEXTUAL_BAR_WAITINGLIST = 'contextual-bar-waitinglist',
  FRAGMENT_0 = 'fragment-0',
  FRAGMENT_1 = 'fragment-1',
  FRAGMENT_2 = 'fragment-2',
  FRAGMENT_3 = 'fragment-3',
  LAYOUT_1 = 'layout-1',
  LAYOUT_APPOINTMENT_DETAIL = 'layout-appointment-detail',
  LAYOUT_CONFIRMATION = 'layout-confirmation',
  PANEL_4 = 'panel-4',
  PANEL_5 = 'panel-5',
  PANEL_APPOINTMENT_0 = 'panel-appointment-0',
  PANEL_APPOINTMENTS = 'panel-appointments',
  PANEL_AWAITINGLIST = 'panel-awaitinglist',
  PANEL_CONTEXTUALBAR_APPOINTMENTS = 'panel-contextualbar-appointments',
  PANEL_CONTEXTUALBAR_REQUESTS = 'panel-contextualbar-requests',
  PANEL_CONTEXTUALBAR_WAITINGLIST = 'panel-contextualbar-waitinglist',
  PANEL_SCHEDULES = 'panel-schedules',
  ROUTE_0 = 'route-0',
}
export { ScheduleConfirmationAliases };
